<div class="zeitauswahl">
    <div class="zeitauswahl-row">
        <div class="zeitauswahl-period">
            <button class="zeitauswahl-nav" mat-flat-button color="accent" (click)="rewind()" type="button">
                <mat-icon>chevron_left</mat-icon>
            </button>

            <mat-form-field class="zeitauswahl-range">
                <mat-label>Zeitspanne eingeben</mat-label>
                <mat-date-range-input [rangePicker]="picker" [dateFilter]="dateFilter" [max]="maxDate">
                    <input
                        matStartDate
                        placeholder="Startdatum"
                        (dateInput)="closedDatepicker()"
                        [formControl]="startDateCtrl"
                    />
                    <input
                        matEndDate
                        placeholder="Enddatum"
                        (dateInput)="closedDatepicker()"
                        [formControl]="endDateCtrl"
                    />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker (closed)="closedDatepicker()"></mat-date-range-picker>
            </mat-form-field>

            <button class="zeitauswahl-nav" mat-flat-button color="accent" (click)="forward()" type="button">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>

        <mat-button-toggle-group
            class="zeitauswahl-intervals"
            (change)="selectZeitinterval($event)"
            [value]="aktuellerZeitinterval"
        >
            <mat-button-toggle value="individuell">Individuell</mat-button-toggle>
            <mat-button-toggle *ngIf="!hideTag" value="tag">Tag</mat-button-toggle>
            <mat-button-toggle value="woche">Woche</mat-button-toggle>
            <mat-button-toggle value="monat">Monat</mat-button-toggle>
            <mat-button-toggle value="quartal">Quartal</mat-button-toggle>
            <mat-button-toggle value="halbjahr">Halbjahr</mat-button-toggle>
            <mat-button-toggle value="jahr">Jahr</mat-button-toggle>
            <mat-button-toggle value="zwei_jahre">2 Jahre</mat-button-toggle>
        </mat-button-toggle-group>

        <mat-form-field *ngIf="!hideAggregate" class="zeitauswahl-aggregate">
            <mat-label>Aggregieren nach</mat-label>
            <mat-select [formControl]="aggregierenCtrl">
                <mat-option value="tag">Tag</mat-option>
                <mat-option value="woche">Woche</mat-option>
                <mat-option value="monat">Monat</mat-option>
                <mat-option value="quartal">Quartal</mat-option>
                <mat-option value="jahr">Jahr</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
